'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.organizationProfile',
dependencies:['ui.router'],
configs:[
require('./organizationProfileConfig')],

components:[
require('./organizationProfileController'),
require('./components/editDataRetentionPeriodModalController')]});
//# sourceMappingURL=index.js.map
